import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

export const selectRouterState = createFeatureSelector<fromRouter.RouterReducerState>('router');
export const selectCurrentRoute = createSelector(selectRouterState, (state: fromRouter.RouterReducerState) =>
  state && state.state && state.state.url
);
